import { api, apiWithoutContentType } from './client';

// Student practice submissions for the coach Syllabus Tracker (Learning
// Zone > Action Songs / Scenes / Stories "Your Practice" panel). Both calls
// are scoped to the logged-in student by the backend - there is no student
// id to pass, mirroring the diary API.

// The shared client aborts requests after 30s, which would cut off a video
// upload mid-way. Give uploads 5 minutes (matches nginx's proxy_read_timeout).
const SUBMISSION_UPLOAD_TIMEOUT_MS = 5 * 60 * 1000;

// `formData` carries: topic, sessionNumber, submissionType ('video' | 'audio' | 'image'),
// note (optional), file.
export const createSyllabusSubmission = async (formData) => {
  const response = await apiWithoutContentType.post('/api/v1/syllabus-submissions', formData, {
    timeout: SUBMISSION_UPLOAD_TIMEOUT_MS,
  });
  return response.data;
};

// This student's own submissions for a Topic (optionally one Session), newest first.
// Resolves to { success, data: { submissions } }.
export const getMySyllabusSubmissions = async ({ topic, sessionNumber } = {}) => {
  const response = await api.get('/api/v1/syllabus-submissions/mine', {
    params: { topic, sessionNumber },
  });
  return response.data;
};
